module.exports = __webpack_public_path__ + "img/banana_yes.3a0c1807.png";